import { useEffect, useState } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import AOS from "aos";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

//Pages & Components
import HomePage from "@/pages/HomePage";
import ServicePage from "@/pages/ServicePage";
import BlogPage from "@/pages/BlogPage";
import TestimonialsPage from "@/pages/TestimonialsPage";
import AboutPage from "@/pages/AboutPage";
import ContactPage from "@/pages/Contact";
import Footer from "@/Component/Footer";
import Navbar from "./Component/Navbar";
import Preloader from "@/Component/Preloader";
import SingleBlog from "@/pages/SingleBlog";
import CaseStudy from "@/pages/CaseStudy";
import ErrorBoundary from "@/Component/ErrorBoundary";

//Styles
import "./App.css";
import "swiper/css";
import "swiper/css/navigation";
import "aos/dist/aos.css";

function App() {
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    AOS.init();
  }, []);

  useEffect(() => {
    window.scrollTo({
      behavior: "instant",
      top: 0,
    });
    AOS.refresh();
    ScrollTrigger.refresh();
  }, [location.pathname]);

  return (
    <>
      {isLoading && <Preloader onComplete={() => setIsLoading(false)} />}
      <Navbar />
      <ErrorBoundary key={location.pathname}>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about-us" element={<AboutPage />} />
          <Route path="/blogs" element={<BlogPage />} />
          <Route path="/testimonials" element={<TestimonialsPage />} />
          <Route path="/services" element={<ServicePage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/blog/:id" element={<SingleBlog />} />
          <Route path="/case-study/:id" element={<CaseStudy />} />
        </Routes>
      </ErrorBoundary>
      <Footer />
    </>
  );
}

export default App;